import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Zpět na přihlášení")

import { NSpace } from 'naive-ui';
import UnauthorizedLayout from '@/layouts/UnauthorizedLayout.vue';
import CreateNewPasswordForm from '@/forms/CreateNewPasswordForm.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(UnauthorizedLayout, {
    width: "300px",
    title: "Nové heslo"
  }, {
    default: _withCtx(() => [
      _createVNode(CreateNewPasswordForm),
      _createVNode(_unref(NSpace), {
        justify: "center",
        class: "pt-m"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: "/",
            class: "text--s"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})